<template>
  <section class="content">
     <section class="content-header">
        <h1>
          {{$route.name}}
        </h1>
      </section>
    <div class="row center-block">
      <!--      <h2>Data tables</h2>-->
      <div class="col-md-12">
        <div class="box user-tb">
          <div class="box-header">
          </div>
          <!-- /.box-header -->
          <div class="box-body">
            <div class="dataTables_wrapper form-inline dt-bootstrap" id="example1_wrapper">
              <div class="row">
                <div class="col-sm-6">
                  <div id="example1_length" class="dataTables_length">
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-sm-12 table-responsive">
                  <table aria-describedby="example1_info" role="grid" id="tableData"
                         class="table table-bordered table-striped dataTable">
                    <thead>
                    <tr role="row">
                      <th aria-label="Rendering engine: activate to sort column descending" aria-sort="ascending"
                          style="width: 25%;" colspan="1" rowspan="1" aria-controls="example1" tabindex="0"
                          class="sorting_asc">Date
                      </th>
                      <th aria-label="CSS grade: activate to sort column ascending" style="width: 25%;" colspan="1"
                          rowspan="1" aria-controls="example1" tabindex="0" class="sorting">Item Total
                      </th>
                      <th aria-label="CSS grade: activate to sort column ascending" style="width: 25%;" colspan="1"
                          rowspan="1" aria-controls="example1" tabindex="0" class="sorting">State
                      </th>
                      <th style="width: 25%" colspan="1" rowspan="1" tabindex="0">Actions</th>
                    </tr>
                    </thead>
                    <tbody></tbody>
                  </table>
                </div>
              </div>
            </div>
            <!-- /.box-body -->
          </div>
        </div>
      </div>
    </div>

     <!-- ================== View Card model ================== -->
    <md-dialog :md-active.sync="editModal" class="model-show-new">
      <md-dialog-title class="model-title modal-width-100">Cart Data
        <a style="float: right;cursor: pointer;" class="md-primary" @click="editModal = false">
          <md-icon class="close-btn" style="font-size: 18px !important;">close
          </md-icon>
        </a>
      </md-dialog-title>
        <form class="from-padding modal-width-100">
          <div class="md-layout md-gutter">
             <div class="cart_list" v-for="(item, index) in ItemList" :key="index">
               <div class="item_image_cart">
                 <img v-bind:src='item.product_details.thumbnail_medium'/>
               </div>
               <div class="item_data_cart">
                 <p class="pr_title">{{item.product_details.name}}</p>
                 <div  v-for="(item, index) in item" :key="index">
                  <p class="pr_datas" v-if="item != null && index != 'product_id' && index != 'id' && index != 'product_details' && index != 'product_description' && index != 'product_type_id' && index != 'qty' && index != 'status' && index != 'modify'  && index != 'color'   ">
                    {{convertToString(index) + ' = ' + item}}
                  </p>
                </div>
                  <p class="pr_datas">
                      Color = {{item.color.name}}
                  </p>
               </div>
               <div class="item_data_qty">
                 <p>Quantity</p>
                 <p class="item_qq">{{item.qty}}</p>
               </div>
             </div>
          </div>
        </form>
<!--      <md-dialog-actions class="model-foot">-->
<!--      </md-dialog-actions>-->
    </md-dialog>
  </section>
</template>

<script>
  import $ from 'jquery'
  // Require needed datatables modules
  require('datatables.net')
  require('datatables.net-bs')
  var SyncLoader = require('vue-spinner/src/SyncLoader')
  import VueNumericInput from 'vue-numeric-input'

  // vue validations
  import {validationMixin} from 'vuelidate'
  import api from '../../../api'
  import config from '../../../config'
  import Vue from 'vue'
  var moment = require('moment')

  export default {
    name: 'UserTeamView',
    components: {
      'SyncLoader': SyncLoader,
      VueNumericInput
    },
    mixins: [validationMixin],
    data() {
      return {
        datatable: null,
        active: false,
        newModal: false,
        editModal: false,
        isSupervisor: false,
        ItemList: [],
        userType: 'user',
        itemId: '',
        order: {
          id: '',
          status: ''
        }
      }
    },
    mounted() {
      this.$nextTick(() => {
        this.initDatatables()
        this.initJqueryMethods()
      })
    },
    methods: {
      convertToString(Text) {
        var txt = Text.toLowerCase().replace(/_/g, ' ')
        var arr = txt.split(' ')
        var newArr = []
        arr.forEach(data => {
          newArr.push(data.charAt(0).toUpperCase() + data.slice(1))
        })
        return newArr.join(' ')
      },
      initDatatables() {
        this.dataTable = $('#tableData')
          .on('xhr.dt', function (e, settings, json, xhr) {
            json.recordsTotal = json.data.original.recordsTotal
            json.draw = json.data.original.draw
            json.recordsFiltered = json.data.original.recordsFiltered
          })
          .DataTable({
            serverSide: true,
            processing: true,
            responsive: true,
            paging: true,
            lengthChange: true,
            searching: true,
            ordering: true,
            info: true,
            autoWidth: false,
            search: {
              'caseInsensitive': false
            },

            order: [[0, 'desc']],
            ajax: {
              url: config.serverURI + '/admin/orders/userwice/user',
              type: 'get',
              contentType: 'application/json; charset=UTF-8',
              dataSrc: 'data.original.data',
              headers: { 'Authorization': 'Bearer ' + Vue.auth.getToken() }
            },
            columnDefs: [
              {
                'orderable': true,
                'targets': [0],
                'responsivePriority': 0,
                'searchable': true,
                'render': function (data, type, full, meta) {
                  return '<span>' + moment(full.date).format('MM/DD/YYYY') + '</span>'
                }
              },
              {
                'orderable': true,
                'targets': [1],
                'responsivePriority': 1,
                'searchable': true,
                'render': function (data, type, full, meta) {
                  return '<span>' + full.order_items.length + '</span>'
                }
              },
              {
                'orderable': true,
                'targets': [2],
                'responsivePriority': 2,
                'searchable': true,
                'render': function (data, type, full, meta) {
                  if (full.status === 'Fully Approved') {
                    return '<span class="badge bg-green">Fully Approved</span>'
                  } else if (full.status === 'Partially Approved') {
                    return '<span class="badge bg-blue">Partially Approved</span>'
                  } else if (full.status === 'Pending') {
                    return '<span class="badge bg-yellow">Pending</span>'
                  } else if (full.status === 'Rejected') {
                    return '<span class="badge bg-red">Rejected</span>'
                  }
                  return '<span class="badge badge-warning">N/A</span>'
                }
              },
              {
                'orderable': false,
                'targets': [3],
                'responsivePriority': 3,
                'searchable': false,
                'className': 'details-control',
                'render': function (data, type, full, meta) {
                  return '<button type="button" data-id= ' + full.id + ' class="btn btn-info btn-sm btn-modal-edit"><i class="fa fa-eye" aria-hidden="true"></i></button>'
                }
              }
            ]
          })
      },
      initJqueryMethods() {
        var ref = this
        // Vuew modal open
        $('#tableData tbody').on('click', 'td.details-control button.btn-modal-edit', function () {
          var id = $(this).attr('data-id')
          ref.showViewModal(id)
        })
      },
      showViewModal(id) {
        this.getCartItems(id)
      },
      getCartItems(id) {
        this.ItemList = []
        api.request('get', '/admin/orders/show/' + id)
          .then(response => {
            if (response.status === 200) {
              this.editModal = true
              this.ItemList = response.data.data.order_items
            } else {
              // eslint-disable-next-line no-undef
              toast.fire({icon: 'error', title: 'Something wrong'})
            }
          }).catch(error => {
          // eslint-disable-next-line no-undef
            toast.fire({icon: 'error', title: error})
          })
      }
    }
  }
</script>

<style>

  @import url('/static/js/plugins/datatables/dataTables.bootstrap.css');

  table.dataTable thead .sorting:after,
  table.dataTable thead .sorting_asc:after,
  table.dataTable thead .sorting_desc:after {
    font-family: 'FontAwesome';
  }

  table.dataTable thead .sorting:after {
    content: '\f0dc';
  }

  table.dataTable thead .sorting_asc:after {
    content: '\f0dd';
  }

  table.dataTable thead .sorting_desc:after {
    content: '\f0de';
  }


</style>



// WEBPACK FOOTER //
// OrderHistory.vue?58222788